
import { RequestedValue$1 } from "../../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray, singleton } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Project_$reflection } from "../../../Shared/User.js";
import { list_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ValidationOnGetRequest } from "../../../ErrorHandling.js";
import { getCustomerConfiguration } from "../../../Requests/Configuration.js";
import { PropertyConfiguration_$reflection } from "../../../Shared/PropertyConfiguration.js";
import { getAccountSettings } from "../../../Requests/Customer.js";

export function init() {
    return [new State(new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, [])), Cmd_batch(ofArray([Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Project_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), "/api/receivers/projects", (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(4, [Item_1]))), getCustomerConfiguration((Item_2) => (new Msg(0, [Item_2])), (Item_3) => (new Msg(4, [Item_3]))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_5;
        return ((url_5 = addPrefix(url_3), (refreshOn_1) => fetchWithDecoder(url_5, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
            const pr_1 = response_2.arrayBuffer();
            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(PropertyConfiguration_$reflection())));
        }, refreshOn_1)))(true).then((_arg_1) => {
            const result_3 = _arg_1;
            return (result_3.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_3.fields[0]);
            })())) : (Promise.resolve(result_3.fields[0]));
        });
    })), "/api/property-configurations", (Item_4) => (new Msg(2, [Item_4])), (Item_5) => (new Msg(4, [Item_5]))), getAccountSettings((Item_6) => (new Msg(3, [Item_6])), (Item_7) => (new Msg(4, [Item_7])))]))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(new RequestedValue$1(1, [msg.fields[0]]), state.CustomerConfiguration, state.PropertyConfigurations, state.AccountSettings), Cmd_none()];
        case 2:
            return [new State(state.Projects, state.CustomerConfiguration, new RequestedValue$1(1, [msg.fields[0]]), state.AccountSettings), Cmd_none()];
        case 3:
            return [new State(state.Projects, state.CustomerConfiguration, state.PropertyConfigurations, new RequestedValue$1(1, [msg.fields[0]])), Cmd_none()];
        case 4:
            return [state, Cmd_none()];
        default:
            return [new State(state.Projects, new RequestedValue$1(1, [msg.fields[0]]), state.PropertyConfigurations, state.AccountSettings), Cmd_none()];
    }
}

